module.exports = __webpack_public_path__ + "img/collection-diamondJewelryGold@2x.7efc3a7.jpg";